import * as React from "react";
import { forwardRef } from "react";
const SvgIcArrowTriangle24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.75 7.81072L9.75 16.1894L13.9393 12.0001L9.75 7.81072ZM9.53033 5.46973L15.5303 11.4697V12.5304L9.53033 18.5304L8.25 18.0001L8.25 6.00006L9.53033 5.46973Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgIcArrowTriangle24);
export { ForwardRef as ReactComponent };
